
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[areaId]/subscriptions/[subscriptionId]/number",
      function () {
        return require("private-next-pages/[areaId]/subscriptions/[subscriptionId]/number.tsx");
      }
    ]);
  